import db from "../database";

export async function getWorkflowData() {
  const [workflowRules, approvers] = await Promise.all([db.POSWorkFlowRules.toArray(), db.approvers.toArray()]);
  return { workflowRules, approvers };
}
